import { environment } from '@y42/environment';

export const UI_MODELING_MODEL_JSON_SCHEMA_URL = `${environment.url.json_schema}/integrations/ui_model/0.0.0/source.json`;
export const UI_MODELING_MODEL_TABLE_JSON_SCHEMA_URL = `${environment.url.json_schema}/integrations/ui_model/0.0.0/table.json`;
export const UI_MODELING_MODEL_DATA_MODEL_JSON_SCHEMA_URL = `${environment.url.json_schema}/integrations/ui_model/0.0.7/model.json`;

export const SQL_MODELING_MODEL_JSON_SCHEMA_URL = `${environment.url.json_schema}/integrations/sql_model/0.0.0/source.json`;
export const SQL_MODELING_MODEL_TABLE_JSON_SCHEMA_URL = `${environment.url.json_schema}/integrations/sql_model/0.0.0/table.json`;
